"use client"

import { ScopeProvider } from "bunshi/react"
import { ApplicationEnvironmentScope, type Env } from "./store"

interface Props {
  children: React.ReactNode
  env: Env
}

export function ApplicationEnvironmentScopeProvider({ children, env }: Props) {
  return (
    <ScopeProvider scope={ApplicationEnvironmentScope} value={env}>
      {children}
    </ScopeProvider>
  )
}
